import React, { useEffect } from 'react';
import { Modal, Button, message } from 'antd';
import styled from 'styled-components';
import { FileDropzone } from './components/file-dropzone.component';
import { UploadingFileList } from './components/uploading-file-list.component';
import { useUploadFiles } from './hooks/use-upload-files.hook';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledModal = styled(Modal).withConfig({
  displayName: "upload-local-file-modalcontainer__StyledModal",
  componentId: "sc-1ceee52-0"
})([".ant-modal-content{border-radius:16px;padding:24px;}.ant-modal-header{border-bottom:none;margin-bottom:24px;padding:0;}.ant-modal-title{font-size:24px;font-weight:700;color:#1a2140;}.ant-modal-body{padding:0;}.ant-modal-footer{border-top:none;margin-top:32px;padding:0;display:flex;justify-content:flex-end;gap:12px;}.ant-modal-close{top:24px;right:24px;}"]);
var Subtitle = styled.div.withConfig({
  displayName: "upload-local-file-modalcontainer__Subtitle",
  componentId: "sc-1ceee52-1"
})(["font-size:15px;color:#64748b;margin-top:8px;"]);
var FooterButton = styled(Button).withConfig({
  displayName: "upload-local-file-modalcontainer__FooterButton",
  componentId: "sc-1ceee52-2"
})(["height:44px;border-radius:10px;font-weight:600;padding:0 24px;"]);
var SaveButton = styled(FooterButton).withConfig({
  displayName: "upload-local-file-modalcontainer__SaveButton",
  componentId: "sc-1ceee52-3"
})(["background-color:#2563eb;border-color:#2563eb;&:hover{background-color:#1d4ed8 !important;border-color:#1d4ed8 !important;}"]);
export var UploadLocalFileModal = function UploadLocalFileModal(_ref) {
  var open = _ref.open,
      onCancel = _ref.onCancel,
      onSave = _ref.onSave,
      isSaving = _ref.isSaving,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? true : _ref$multiple,
      onBeforeUpload = _ref.onBeforeUpload,
      onDeleteFile = _ref.onDeleteFile,
      allowedFileTypes = _ref.allowedFileTypes;

  var _useUploadFiles = useUploadFiles(),
      files = _useUploadFiles.files,
      onFilesSelected = _useUploadFiles.onFilesSelected,
      removeFile = _useUploadFiles.removeFile,
      clearFiles = _useUploadFiles.clearFiles; // Clear files when modal closes


  useEffect(function () {
    if (!open) {
      clearFiles();
    }
  }, [open, clearFiles]);

  var handleRemoveFile = function handleRemoveFile(file) {
    removeFile(file);
    onDeleteFile === null || onDeleteFile === void 0 ? void 0 : onDeleteFile(file);
  };

  var handleSave = function handleSave() {
    var fileList = files.map(function (item) {
      return item.file;
    });

    if (allowedFileTypes && allowedFileTypes.length > 0) {
      // Check if file type is allowed
      var hasInvalidFileType = fileList.some(function (f) {
        return allowedFileTypes.every(function (ext) {
          return f.name.toLowerCase().endsWith(ext);
        });
      });

      if (hasInvalidFileType) {
        message.error("Only [".concat(allowedFileTypes.join(', '), "] files are allowed"));
        return;
      }
    }

    if (onBeforeUpload) {
      fileList = onBeforeUpload(fileList);
    }

    onSave(fileList);
    clearFiles();
  };

  var handleCancel = function handleCancel() {
    clearFiles();
    onCancel();
  };

  return /*#__PURE__*/_jsxs(StyledModal, {
    open: open,
    onCancel: handleCancel,
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: ["Upload Local Files", /*#__PURE__*/_jsx(Subtitle, {
        children: "Select files from your device to upload into your chat."
      })]
    }),
    footer: [/*#__PURE__*/_jsx(FooterButton, {
      onClick: handleCancel,
      disabled: isSaving,
      children: "Cancel"
    }, "cancel"), /*#__PURE__*/_jsx(SaveButton, {
      type: "primary",
      onClick: handleSave,
      disabled: files.length === 0,
      loading: isSaving,
      children: "Save Files"
    }, "save")],
    width: 560,
    centered: true,
    children: [/*#__PURE__*/_jsx(FileDropzone, {
      onFilesSelected: onFilesSelected,
      disabled: !!isSaving,
      multiple: multiple
    }), /*#__PURE__*/_jsx(UploadingFileList, {
      files: files,
      onRemove: handleRemoveFile
    })]
  });
};